import { getYQFromStatementId } from '..';

/**
 * Given an array of statement IDs, sort them by last statement first, then take the first and last
 * statement IDs, separate them by a dash, and return as a single string. This string should then be
 * encoded with encodeURIComponent and set in the URL as a single search parameter.
 *
 * @param statementIds the array of statement IDs to save as a URL search parameter
 */
export const getStatementsURLSearchParam = (
    statementIds: string[],
): string | null => {
    if (statementIds.length < 1) {
        return null;
    }

    if (statementIds.length === 1) {
        // If there is only one statementId, just return it without the dash
        return statementIds[0];
    }

    const sorted = statementIds.sort((a: string, b: string): number => {
        const yearQuarterA = getYQFromStatementId(a);
        const yearQuarterB = getYQFromStatementId(b);

        if (yearQuarterA === null || yearQuarterB === null) {
            return 0;
        }

        if (yearQuarterA < yearQuarterB) {
            return 1;
        }

        if (yearQuarterA > yearQuarterB) {
            return -1;
        }

        return 0;
    });

    return `${sorted[0]}-${sorted[sorted.length - 1]}`;
};
